/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://dev.eggedplus.co.il/api/swagger/v1/swagger.json **/

import axios from "../axios"
import * as EsEim from "./EsEimInterfaces"

export const postCareerHeadquartersApply = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string,
) =>
  axios.post<EsEim.BooleanResponseWrapper>(
    `/api/career/headquartersApply`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    },
  )

export const postCareerDriverOrCollegeApply = (
  data: EsEim.CallboxPublicRequest,
  locale?: string,
) =>
  axios.post<EsEim.BooleanResponseWrapper>(
    `/api/career/driverOrCollegeApply`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCareerAllHeadquartersJobs = (
  data: EsEim.GetHeadquartersJobsRequest,
  locale?: string,
) =>
  axios.post<EsEim.HeadquarterJobPublicResponsePaginatedListResultResponseWrapper>(
    `/api/career/allHeadquartersJobs`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCareerHeadquarterJob = (
  jobId: number /* int32 */,
  locale?: string,
) =>
  axios.get<EsEim.HeadquarterJobExtendedPublicResponseResponseWrapper>(
    `/api/career/headquarterJob`,
    { params: { jobId }, headers: { "X-Accept-Language": locale } },
  )

export const getContactsUsTypes = (locale?: string) =>
  axios.get<EsEim.Int32StringValueTupleListResponseWrapper>(
    `/api/contactsUs/types`,
    { headers: { "X-Accept-Language": locale } },
  )

export const postContactsUsCreate = (
  data: EsEim.CreateContactUsPublicRequest,
  locale?: string,
) =>
  axios.post<EsEim.InsertComplaintPublicResponseResponseWrapper>(
    `/api/contactsUs/create`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postEggedPlusAccidentReportSubmit = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string,
) =>
  axios.post<EsEim.BooleanResponseWrapper>(
    `/api/eggedPlusAccidentReport/submit`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    },
  )

export const postEggedPlusContactSubmit = (
  data: EsEim.CreateEggedPlusContactPublicRequest,
  locale?: string,
) =>
  axios.post<EsEim.BooleanResponseWrapper>(
    `/api/eggedPlusContact/submit`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postEggedPlusDriverCareerSubmit = (
  data: EsEim.CreateEggedPlusDriverCareerPublicRequest,
  locale?: string,
) =>
  axios.post<EsEim.BooleanResponseWrapper>(
    `/api/eggedPlusDriverCareer/submit`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postEggedPlusGeneralCareerSubmit = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string,
) =>
  axios.post<EsEim.BooleanResponseWrapper>(
    `/api/eggedPlusGeneralCareer/submit`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    },
  )

export const getFinesDetails = (
  fineId: number /* int64 */,
  fineNumerator: number /* int64 */,
  recaptcha: string,
  locale?: string,
) =>
  axios.get<EsEim.FineDetailsPublicResponseResponseWrapper>(
    `/api/fines/details`,
    {
      params: { fineId, fineNumerator, recaptcha },
      headers: { "X-Accept-Language": locale },
    },
  )

export const postFinesPayment = (
  data: EsEim.FinePaymentRequest,
  locale?: string,
) =>
  axios.post<EsEim.PaymentSetupPublicResponseResponseWrapper>(
    `/api/fines/payment`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getFinesPaymentDone = (
  Succeed: boolean,
  TxId: string,
  UniqueID: string,
  ErrorCode: string,
  ErrorText: string,
  Lang: string,
  Mid: string,
  CardExp: string,
  PersonalId: string,
  CardToken: string,
  CardMask: string,
  NumberOfPayments: number /* int32 */,
  FirstPayment: string,
  PeriodicalPayment: string,
  CgUid: string,
  ResponseMac: string,
  UserData2: string,
  UserData3: string,
  UserData4: string,
  UserData5: string,
  locale?: string,
) =>
  axios.get<any>(`/api/fines/paymentDone`, {
    params: {
      Succeed,
      TxId,
      UniqueID,
      ErrorCode,
      ErrorText,
      Lang,
      Mid,
      CardExp,
      PersonalId,
      CardToken,
      CardMask,
      NumberOfPayments,
      FirstPayment,
      PeriodicalPayment,
      CgUid,
      ResponseMac,
      UserData2,
      UserData3,
      UserData4,
      UserData5,
    },
    headers: { "X-Accept-Language": locale },
  })

export const getSettingsAll = (locale?: string) =>
  axios.get<EsEim.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getLostFoundCaseStatus = (
  caseNumber: number /* double */,
  phoneNumber: number /* double */,
  locale?: string,
) =>
  axios.get<EsEim.LostFoundCaseStatusPublicResponseResponseWrapper>(
    `/api/lostFound/caseStatus`,
    {
      params: { caseNumber, phoneNumber },
      headers: { "X-Accept-Language": locale },
    },
  )

export const getLostFoundColors = (locale?: string) =>
  axios.get<EsEim.LostFoundColorPublicResponseListResponseWrapper>(
    `/api/lostFound/colors`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getLostFoundContent = (locale?: string) =>
  axios.get<EsEim.LostFoundContentPublicResponseListResponseWrapper>(
    `/api/lostFound/content`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getLostFoundTrip = (
  shilut: number /* double */,
  lostDate: string /* date-time */,
  locale?: string,
) =>
  axios.get<EsEim.LostFoundTripDetailsPublicResponseListResponseWrapper>(
    `/api/lostFound/trip`,
    { params: { shilut, lostDate }, headers: { "X-Accept-Language": locale } },
  )

export const postLostFoundCreateCase = (
  data: EsEim.LostFoundCreateCasePublicRequest,
  locale?: string,
) =>
  axios.post<EsEim.LostFoundCasePublicResponseResponseWrapper>(
    `/api/lostFound/createCase`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getTestLocalDateTime = (locale?: string) =>
  axios.get<EsEim.DateTimeResponseWrapper>(`/api/test/localDateTime`, {
    headers: { "X-Accept-Language": locale },
  })

export const postTrafficUpdateAll = (
  data: EsEim.TrafficUpdatesRequest,
  locale?: string,
) =>
  axios.post<EsEim.TrafficUpdatesDtoResponseWrapper>(
    `/api/trafficUpdate/all`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getTrafficUpdateGetById = (
  messageId: number /* int64 */,
  locale?: string,
) =>
  axios.get<EsEim.ExtendedTrafficUpdateDtoResponseWrapper>(
    `/api/trafficUpdate/getById`,
    { params: { messageId }, headers: { "X-Accept-Language": locale } },
  )
